"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPushNotificationType = mapPushNotificationType;
exports.mapPushReferenceModel = mapPushReferenceModel;
exports.buildPushNotificationPayload = buildPushNotificationPayload;
const enums_1 = require("../enums");
/**
 * Mobile app resolves navigation in this order:
 * 1. BackgroundedAppPing → ignore
 * 2. deepLinkTarget (when set)
 * 3. referenceModel (Venue → venuePeek, Breadcrumb, BreadcrumbReply)
 * 4. type fallback (MessageReceived, LikeReceived, BreadcrumbReceived, …)
 */
const PUSH_NOTIFICATION_TYPE_ALIASES = {
  [enums_1.NotificationType.VenueBreadcrumbLiked]: 'BreadcrumbReceived',
  [enums_1.NotificationType.VenueBreadcrumbReplyReceived]: 'BreadcrumbReplyReceived'
};
const PUSH_REFERENCE_MODEL_ALIASES = {
  [enums_1.ModelName.VenueBreadcrumb]: 'Breadcrumb',
  [enums_1.ModelName.VenueBreadcrumbReply]: 'BreadcrumbReply'
};
/** Keys the mobile client reads from the top level of push `data` (not inside extraData). */
const PUSH_TOP_LEVEL_EXTRA_KEYS = new Set(['actorUserPublicId', 'deepLinkTarget']);
function omitEmptyRecord(source) {
  const result = {};
  for (const [key, value] of Object.entries(source)) {
    if (value == null) {
      continue;
    }
    if (typeof value === 'string' && value.trim().length === 0) {
      continue;
    }
    result[key] = typeof value === 'string' ? value.trim() : value;
  }
  return result;
}
function mapPushNotificationType(type) {
  var _PUSH_NOTIFICATION_TY;
  return (_PUSH_NOTIFICATION_TY = PUSH_NOTIFICATION_TYPE_ALIASES[type]) !== null && _PUSH_NOTIFICATION_TY !== void 0 ? _PUSH_NOTIFICATION_TY : type;
}
function mapPushReferenceModel(referenceModel) {
  var _PUSH_REFERENCE_MODEL;
  if (referenceModel == null) {
    return null;
  }
  return (_PUSH_REFERENCE_MODEL = PUSH_REFERENCE_MODEL_ALIASES[referenceModel]) !== null && _PUSH_REFERENCE_MODEL !== void 0 ? _PUSH_REFERENCE_MODEL : referenceModel;
}
/**
 * Builds the OneSignal `data` object sent to the mobile app.
 *
 * Shape:
 * - `type`, `referenceModel`, `referenceId`, `actorUserPublicId`, `deepLinkTarget` — top level
 * - navigation / metadata — nested `extraData`
 */
function buildPushNotificationPayload(input) {
  var _input$extraData, _input$deepLinkTarget;
  const source = _objectSpread({}, (_input$extraData = input.extraData) !== null && _input$extraData !== void 0 ? _input$extraData : {});
  const deepLinkTarget = (_input$deepLinkTarget = input.deepLinkTarget) !== null && _input$deepLinkTarget !== void 0 ? _input$deepLinkTarget : typeof source.deepLinkTarget === 'string' ? source.deepLinkTarget : null;
  const actorUserPublicId = typeof source.actorUserPublicId === 'string' ? source.actorUserPublicId : null;
  for (const key of PUSH_TOP_LEVEL_EXTRA_KEYS) {
    delete source[key];
  }
  const extraData = omitEmptyRecord(source);
  const payload = {
    type: mapPushNotificationType(input.type),
    referenceModel: mapPushReferenceModel(input.referenceModel),
    referenceId: input.referenceId
  };
  const trimmedDeepLink = deepLinkTarget === null || deepLinkTarget === void 0 ? void 0 : deepLinkTarget.trim();
  if (trimmedDeepLink) {
    payload.deepLinkTarget = trimmedDeepLink;
  }
  const trimmedActor = actorUserPublicId === null || actorUserPublicId === void 0 ? void 0 : actorUserPublicId.trim();
  if (trimmedActor) {
    payload.actorUserPublicId = trimmedActor;
  }
  if (Object.keys(extraData).length > 0) {
    payload.extraData = extraData;
  }
  return payload;
}
//# sourceMappingURL=push-notification-payload.js.map